import { topbarSize } from '../../../../../constants/sizes';

export default {
  container: {
    display: 'flex',
    flex: '1 0 auto',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: `calc(100vh - ${topbarSize}px)`
  }
};
